module.exports = __webpack_public_path__ + "static/media/light-motion-deployment-optimisation.4db7b92.mp4";